import React from 'react'
import { EmotionCache, Global } from '@emotion/react'
import { ThemeProvider as MuiThemeProvider, Theme, CssBaseline } from '@mui/material'
import { muiTheme } from 'src/components/theme/mui'
import { globalStyle } from 'src/components/theme/global'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

type ThemeProviderProps = {
  children?: React.ReactNode
  emotionCache?: EmotionCache
}

export const ThemeProvider = (props: ThemeProviderProps) => {
  const { children } = props
  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      <Global styles={globalStyle} />
      {children}
    </MuiThemeProvider>
  )
}
